export default __webpack_public_path__ + "static/media/clouds.2e71c25d.png";